import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <p>© {year} - Colombe Raby</p>
    </footer>
  );
}

export default Footer;
